import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  breadcrumbs: {
    maxWidth: 1080,
    boxSizing: 'border-box',
    padding: '11.5px 16px',
    margin: '0 auto 0 auto',
    [Theme.breakpoints.up('sm')]: {
      padding: '10px 30px',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '10px 50px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '10px 0',
    },
    '&.extended': {
      maxWidth: 1440,
      padding: '10px 16px',
      [Theme.breakpoints.only('md')]: {
        padding: '10px 40px',
      },
      [Theme.breakpoints.up('lg')]: {
        padding: '10px 24px',
      },
    },
    '& p': {
      fontFamily: Theme.typography.base.regular,
      whiteSpace: 'nowrap',
    },
    '& svg': {
      color: Theme.palette.gray[250],
      width: '20px',
      height: '20px',
      [Theme.breakpoints.up('md')]: {
        width: '24px',
        height: '24px',
      },
    },
    '& .MuiBreadcrumbs-separator': {
      margin: '0px 5px',
      [Theme.breakpoints.up('md')]: {
        margin: '0px 10px',
      },
    },
    '& .MuiBreadcrumbs-ol': {
      margin: '0',
      display: 'flex',
      padding: '0',
      flexWrap: 'nowrap',
      listStyle: 'none',
      alignItems: 'center',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
      maxHeight: '20px',
      [Theme.breakpoints.up('md')]: {
        maxHeight: '24px',
      },
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
}));

export default useStyles;
